import { render, staticRenderFns } from "./chartSumCompaniesMonths.vue?vue&type=template&id=158d2a54&scoped=true&"
import script from "./chartSumCompaniesMonths.vue?vue&type=script&lang=js&"
export * from "./chartSumCompaniesMonths.vue?vue&type=script&lang=js&"
import style0 from "./chartSumCompaniesMonths.vue?vue&type=style&index=0&id=158d2a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d2a54",
  null
  
)

export default component.exports